import React from "react";
import AuthConsumer from "../auth/useAuth.jsx";

export default function withAuth(Component)
{
    return React.forwardRef( (props, ref) => {
    
        const auth = AuthConsumer();

        return <Component ref={ref} auth={auth} {...props} />;
    });
};
